import axios from "axios";
import config from "../config/constants";
import { toastr } from 'react-redux-toastr';
import store from '../index';
import info from "../config/messages";

export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const OPEN_SIDEBAR = "OPEN_SIDEBAR";
export const GET_LOGGED_USER = "GET_LOGGED_USER";

export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    console.log(error);
    if (error.response) {
      if (error.response.status === 401) {
          store.dispatch({
              type: USER_LOGGED_OUT,
              payload: null
          });
      }else{
          if(error.response.data){
              if(error.response.data.title){
                  toastr.error("Error", error.response.data.title);
              } else  if(error.response.data.error){
                  toastr.error("Error", error.response.data.error);
              } else  if(error.response.data.Error){
                  toastr.error("Error", error.response.data.Error);
              } else{
                  toastr.error("Unknown Error", "Please refer the console logs for more details on the error.");
              }
          }else{
              if (error.response) {
                  toastr.error("Error", error.response);
              } else {
                  toastr.error("Unknown Error", "Please refer the console logs for more details on the error.");
              }
          }
      }
    } else{
      toastr.error("Error", error.message);
    }
    return Promise.reject(error);
});

export const loginWithTokens = (props = {}, history) => {
    const { id_token, access_token, refresh_token } = props;
    let data ={};
    data["IdToken"] = id_token || '';
    data["AccessToken"] = access_token || '';
    data["RefreshToken"] = refresh_token || '';
    console.log("Login with Tokens");
    return (dispatch, getState) => {
       dispatch({
                type: USER_LOGGED_IN,
                payload: data
       });
       dispatch(getLoggedUser());
       history.push('/');
    }
};

export const login = (props) => {
    return (dispatch, getState) => {
        axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/auth/authenticate', props).then(({ data }) => {
            dispatch({
                type: USER_LOGGED_IN,
                payload: data
            });
            dispatch(getLoggedUser());
        }).catch(function (error) {
            toastr.error('Login Failed', 'Please check the username and password');
        });
    }
}

export const refreshToken = (props) => {
    console.log("Refreshing token1");
    console.log(props);
    axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/auth/refresh', props).then(({ data }) => {
            console.log("Refreshing token response received");
            console.log(data);
            store. dispatch({
                type: USER_LOGGED_IN,
                payload: data
            });
    }).catch(function (error) {
            toastr.error('Refreshing Token Failed', 'Login again');
            store.dispatch({
              type: USER_LOGGED_OUT,
              payload: null
          });
    });
}

export const logout = () => {
    return (dispatch, getState) => {
        dispatch({
            type: USER_LOGGED_OUT,
            payload: null
        });
    }
}

export const openSidebar = () => {
    return (dispatch, getState) => {
        dispatch({
            type: OPEN_SIDEBAR
        });
    }
}

export const getLoggedUser = () => {
    return (dispatch, getState) => {
        axios.get(config.PROJECT_DASHBOARD_API_URL + 'aiservice/account').then(({ data }) => {
            dispatch({
                type: GET_LOGGED_USER,
                payload: data
            });
        }).catch(function (error) {
            console.log("error", error && error.response);
            toastr.error(info.Failed.User.getLoggedUser, error && error.response && error.response.data && error.response.data.error);
        });
    }
}


export const changePassword = (props, scope) => {
    let token = JSON.parse(localStorage.getItem("token"));
    console.log(token);
    props["access_token"]=token["AccessToken"]
    console.log("Updating password");
    console.log(props);
    return (dispatch, getState) => {
            axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/account/change-password', props).then(({ data }) => {
                dispatch({
                    type: CHANGE_PASSWORD,
                    payload: props
                });
                toastr.success(info.Success.User.updatePassword);
            }).catch(function (error) {
                console.log("error", error.response);
                toastr.error(info.Failed.User.updatePassword, error.response.data.error);
            });
    }
}

export const updateProfile = (props, scope) => {
    let token = JSON.parse(localStorage.getItem("token"));
    props["access_token"]=token["AccessToken"]
    console.log("Updating profile");
    console.log(props);
    return (dispatch, getState) => {
            axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/account', props).then(({ data }) => {
                dispatch({
                    type: UPDATE_PROFILE,
                    payload: props
                });
                toastr.success(info.Success.User.updateProfile);
            }).catch(function (error) {
                console.log("error", error.response);
                toastr.error(info.Failed.User.updateProfile, error.response.data.error);
            });
    }
}


export const loadProcessToken = () => {
    let token = localStorage.getItem('token') || null;
    if (token) {
        token = JSON.parse(token);
        let time_expired = Date.now() - token["timestamp"];
        let expiry_window =(token['ExpiresIn'] -1800) * 1000;
        console.log(time_expired);
        console.log(expiry_window);
        axios.defaults.headers.common['Authorization'] = "Bearer " + token["IdToken"];
        if ( time_expired > expiry_window && !token["refresh_request"]){
            console.log("Sending token refresh request");
            token["refresh_request"] = true;
            localStorage.setItem('token', JSON.stringify(token));
            refreshToken(token);
        }
    }
    return token
}



// WEBPACK FOOTER //
// ./src/actions/index.js